// API Configuration
// This file manages the base URL for all API calls

class ApiConfig {
  constructor() {
    // Default to localhost for development
    this.baseURL = this.getBaseURL();
  }

  getBaseURL() {
    // Priority order for determining the base URL:
    // 1. Environment variable (for build-time configuration)
    // 2. Window global variable (for runtime configuration)
    // 3. Local storage (for user preference)
    // 4. Default localhost

    // Check for environment variable first
    if (process.env.REACT_APP_API_BASE_URL) {
        console.log("Using API base URL from environment variable:", process.env.REACT_APP_API_BASE_URL);
        return process.env.REACT_APP_API_BASE_URL;
    }
 
    // Check for runtime configuration
    if (window.API_BASE_URL) {
      return window.API_BASE_URL;
    }

    // Check local storage
    const storedBaseURL = localStorage.getItem('API_BASE_URL');
    if (storedBaseURL) {
      return storedBaseURL;
    }

    // Default fallback
    return '';
  }

  setBaseURL(url) {
    this.baseURL = url;
    // Store in localStorage for persistence
    localStorage.setItem('API_BASE_URL', url);
  }

  getFullURL(path) {
    // Ensure path starts with /
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return `${this.baseURL}${normalizedPath}`;
  }
}

// Create a singleton instance
const apiConfig = new ApiConfig();

export default apiConfig;
